export const alphabet = [
  { letter: 'أ', name: 'Alif', sound: 'a', emoji: '🍎', word: 'تفاحة', wordEn: 'Apple' },
  { letter: 'ب', name: 'Ba', sound: 'b', emoji: '🏠', word: 'بيت', wordEn: 'House' },
  { letter: 'ت', name: 'Ta', sound: 't', emoji: '🍅', word: 'تين', wordEn: 'Fig' },
  { letter: 'ث', name: 'Tha', sound: 'th', emoji: '🐍', word: 'ثعبان', wordEn: 'Snake' },
  { letter: 'ج', name: 'Jim', sound: 'j', emoji: '🐪', word: 'جمل', wordEn: 'Camel' },
  { letter: 'ح', name: 'Ha', sound: 'h', emoji: '🐴', word: 'حصان', wordEn: 'Horse' },
  { letter: 'خ', name: 'Kha', sound: 'kh', emoji: '🗺️', word: 'خريطة', wordEn: 'Map' },
  { letter: 'د', name: 'Dal', sound: 'd', emoji: '�ب', word: 'دب', wordEn: 'Bear' },
  { letter: 'ذ', name: 'Dhal', sound: 'dh', emoji: '🌽', word: 'ذرة', wordEn: 'Corn' },
  { letter: 'ر', name: 'Ra', sound: 'r', emoji: '🤸', word: 'رياضة', wordEn: 'Sport' },
  { letter: 'ز', name: 'Zain', sound: 'z', emoji: '🌼', word: 'زهرة', wordEn: 'Flower' },
  { letter: 'س', name: 'Sin', sound: 's', emoji: '🐟', word: 'سمكة', wordEn: 'Fish' },
  { letter: 'ش', name: 'Shin', sound: 'sh', emoji: '☀️', word: 'شمس', wordEn: 'Sun' },
  { letter: 'ص', name: 'Sad', sound: 's', emoji: '🦁', word: 'صبر', wordEn: 'Patience' },
  { letter: 'ض', name: 'Dad', sound: 'd', emoji: '🐸', word: 'ضفدع', wordEn: 'Frog' },
  { letter: 'ط', name: 'Ta', sound: 't', emoji: '✈️', word: 'طائرة', wordEn: 'Airplane' },
  { letter: 'ظ', name: 'Dha', sound: 'dh', emoji: '🦌', word: 'ظبي', wordEn: 'Deer' },
  { letter: 'ع', name: 'Ain', sound: "'", emoji: '👁️', word: 'عين', wordEn: 'Eye' },
  { letter: 'غ', name: 'Ghain', sound: 'gh', emoji: '🦤', word: 'غراب', wordEn: 'Crow' },
  { letter: 'ف', name: 'Fa', sound: 'f', emoji: '🦋', word: 'فراشة', wordEn: 'Butterfly' },
  { letter: 'ق', name: 'Qaf', sound: 'q', emoji: '🏰', word: 'قلعة', wordEn: 'Castle' },
  { letter: 'ك', name: 'Kaf', sound: 'k', emoji: '🐶', word: 'كلب', wordEn: 'Dog' },
  { letter: 'ل', name: 'Lam', sound: 'l', emoji: '🦁', word: 'ليث', wordEn: 'Lion' },
  { letter: 'م', name: 'Mim', sound: 'm', emoji: '🌙', word: 'مندر', wordEn: 'Moon' },
  { letter: 'ن', name: 'Nun', sound: 'n', emoji: '⭐', word: 'نجمة', wordEn: 'Star' },
  { letter: 'ه', name: 'Ha', sound: 'h', emoji: '🌙', word: 'هلال', wordEn: 'Crescent' },
  { letter: 'و', name: 'Waw', sound: 'w', emoji: '🌹', word: 'وردة', wordEn: 'Rose' },
  { letter: 'ي', name: 'Ya', sound: 'y', emoji: '✋', word: 'يد', wordEn: 'Hand' },
];

export const numbers = [
  { num: '١', arabic: 'واحد', english: 'One', emoji: '☝️', val: 1 },
  { num: '٢', arabic: 'اثنان', english: 'Two', emoji: '✌️', val: 2 },
  { num: '٣', arabic: 'ثلاثة', english: 'Three', emoji: '🤟', val: 3 },
  { num: '٤', arabic: 'أربعة', english: 'Four', emoji: '🖐️', val: 4 },
  { num: '٥', arabic: 'خمسة', english: 'Five', emoji: '🖐️', val: 5 },
  { num: '٦', arabic: 'ستة', english: 'Six', emoji: '6️⃣', val: 6 },
  { num: '٧', arabic: 'سبعة', english: 'Seven', emoji: '7️⃣', val: 7 },
  { num: '٨', arabic: 'ثمانية', english: 'Eight', emoji: '8️⃣', val: 8 },
  { num: '٩', arabic: 'تسعة', english: 'Nine', emoji: '9️⃣', val: 9 },
  { num: '١٠', arabic: 'عشرة', english: 'Ten', emoji: '🔟', val: 10 },
];

export const colors = [
  { arabic: 'أحمر', english: 'Red', hex: '#FF6B6B', emoji: '🔴' },
  { arabic: 'أزرق', english: 'Blue', hex: '#4ECDC4', emoji: '🔵' },
  { arabic: 'أخضر', english: 'Green', hex: '#95E1D3', emoji: '🟢' },
  { arabic: 'أصفر', english: 'Yellow', hex: '#FFE66D', emoji: '🟡' },
  { arabic: 'برتقالي', english: 'Orange', hex: '#FF9F43', emoji: '🟠' },
  { arabic: 'بنفسجي', english: 'Purple', hex: '#6C63FF', emoji: '🟣' },
  { arabic: 'وردي', english: 'Pink', hex: '#FD79A8', emoji: '🩷' },
  { arabic: 'أبيض', english: 'White', hex: '#DFE6E9', emoji: '⬜' },
  { arabic: 'أسود', english: 'Black', hex: '#2D3436', emoji: '⬛' },
];

export const animals = [
  { arabic: 'قطة', english: 'Cat', emoji: '🐱' },
  { arabic: 'كلب', english: 'Dog', emoji: '🐶' },
  { arabic: 'أسد', english: 'Lion', emoji: '🦁' },
  { arabic: 'فيل', english: 'Elephant', emoji: '🐘' },
  { arabic: 'زرافة', english: 'Giraffe', emoji: '🦒' },
  { arabic: 'قرد', english: 'Monkey', emoji: '🐒' },
  { arabic: 'طائر', english: 'Bird', emoji: '🐦' },
  { arabic: 'سمكة', english: 'Fish', emoji: '🐟' },
];

export const greetings = [
  { arabic: 'مرحبا', english: 'Hello', emoji: '👋' },
  { arabic: 'شكراً', english: 'Thank you', emoji: '🙏' },
  { arabic: 'من فضلك', english: 'Please', emoji: '🤲' },
  { arabic: 'أحبك', english: 'I love you', emoji: '❤️' },
  { arabic: 'صباح الخير', english: 'Good morning', emoji: '🌅' },
  { arabic: 'مساء الخير', english: 'Good evening', emoji: '🌙' },
  { arabic: 'تصبح على خير', english: 'Good night', emoji: '💤' },
  { arabic: 'يلا', english: "Let's go!", emoji: '🚀' },
];
